import React from 'react'

import Icon from '../shapes/Icon'
import LabelListItem from './LabelListItem'

const LabelIconListItem = ({ icon, leftIcon, rightIcon, rightContent, leftContent, iconSize, iconColor, ...props }) => {
  return (
    <LabelListItem
      {...props}
      leftContent={
        leftContent || (leftIcon && <Icon name={leftIcon} size={iconSize} color={iconColor || props.color} />)
      }
      rightContent={
        rightContent ||
        ((rightIcon || icon) && <Icon name={rightIcon || icon} size={iconSize} color={iconColor || props.color} />)
      }
    />
  )
}

export default LabelIconListItem
